export const capitalize = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1)

export const formatPrice = (price?: number) =>
  price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') ?? ''
